import { drawImage } from './images.js'
import { SprayingWater, tileset, currentLevel, CoordinatesToTileIndex, tempIncreaseRate } from './main.js'

class Player {
    constructor(x, y) {
        this.x = x
        this.y = y
        this.movement = { x: 0, y: 0 }
        this.waterLevel = 1
        this.standingInWater = false
        this.temp = 0
        this.radius = 3

        this.score = 0

        this.state = 'Walk'
        this.dir = 'right'

        this.animationFrame = 0
        this.animationFramesCount = 4
        this.animationSpeed = 0.09

    }

    AnimationFrame(frame) {
        if (frame !== undefined) {
            this.animationFrame = frame
        }
        return parseInt(this.animationFrame)
    }

    ShouldAnimationPlay() {
        if (this.state === 'Walk') {
            return (this.movement.x === 0 && this.movement.y === 0)
        }
        return false
    }

    AnimationAdvance(delta) {
        if (this.ShouldAnimationPlay()) {
            return parseInt(this.animationFrame)
        }
        this.animationFrame += delta * this.animationSpeed
        if (this.animationFrame > this.animationFramesCount) {
            this.animationFrame = 0
        }
        return parseInt(this.animationFrame)
    }

    SetDirection(dir) {
        this.dir = dir
    }

    Draw(offsetx, offsety) {
        drawImage(this.state + '-' + this.dir, parseInt(this.x + offsetx) - 2, parseInt(this.y + offsety) - 3, { x: this.AnimationFrame() * 8, y: 0, w: 8, h: 8 })
    }

    GetDamageTiles() {
        let tiles = []
        for (let ty = this.y - this.radius; ty < this.y + this.radius; ty++) {
            for (let tx = this.x - this.radius; tx < this.x + this.radius; tx++) {
                let cx = parseInt((tx + 4) / tileset.tilewidth)
                let cy = parseInt((ty) / tileset.tileheight)
                if (cx >= 0 && cy >= 0 && cx <= currentLevel.width && cy <= currentLevel.height) {
                    let index = CoordinatesToTileIndex(cx, cy)
                    if (currentLevel.flames[index] > 0) {
                        tiles.push({ x: cx, y: cy})
                    }
                }
            }
        }
        return tiles
    }

    Update(delta) {
        delta = delta ? delta : 16
        let dx = this.movement.x * delta
        let dy = this.movement.y * delta

        if (!SprayingWater()) {
            if (dx > 0) {
                this.dir = 'right'
            } else if (dx < 0) {
                this.dir = 'left'
            }

            if (dy > 0) {
                this.dir = 'down'
            } else if (dy < 0) {
                this.dir = 'up'
            }
        }
        this.x += dx
        this.y += dy

        let dmg = this.GetDamageTiles()
        if (dmg.length > 0) {
            this.temp += tempIncreaseRate * delta
        }

        let index = CoordinatesToTileIndex(parseInt(this.x / tileset.tilewidth), parseInt(this.y / tileset.tileheight))
        let tileIndex = currentLevel.layers[0].data[index] - 1
        let baseTile = tileset.tiles.filter(f => f.id === tileIndex)
        if (baseTile.length > 0 && baseTile[0].class === 'Water') {
            this.standingInWater = true
        } else {
            this.standingInWater = false
        }

        this.AnimationAdvance(delta)
    }
}

export default Player